import * as React from 'react';
import { getIdentityProviders, updateIdp, getApplicationPermissions, deleteCompany, getRealmUserCount } from '../../ApiUtils/ApiUtils';
import IdpConfigureForm from './IdpConfigureForm';
import './ManagementStyling.css';
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import CompanyCreateForm from './CompanyCreateForm'
import { FormEvent } from 'react';
import { Input } from 'reactstrap';
import { SyntheticEvent } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import CompanyUrlsForm from './CompanyUrlsForm';
import SupportTeam from '../Console/Dashboard/SupportTeam';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

type Props = {}

interface IdPEntity {
    alias: string;
    displayName: string;
    internalId: string;
    providerId: string;
    enabled: boolean;
    updateProfileFirstLoginMode: string;
    trustEmail: boolean;
    storeToken: boolean;
    addReadTokenRoleOnCreate: boolean;
    authenticateByDefault: boolean;
    linkOnly: boolean;
    firstBrokerLoginFlowAlias: string;
    postBrokerLoginFlowAlias: string;
    config: {
        samlXmlKeyNameTranformer: string;
        nameIDPolicyFormat: string;
        syncMode: string;
        singleSignOnServiceUrl: string;
        principalType: string;
        signatureAlgorithm: string;
        useJwksUrl: boolean;
        guiOrder: string;
        [key: string]: any;

    }
}

const InitialState: {
    data: IdPEntity[], domains: string[], dialogVisible: boolean, configName: string, root: boolean, createFormOpen: boolean,
    submitErrors: string[], displayDeleteCompanyDialog: boolean, targetRealm: string, targetIdpAlias: string, displayUserExistingDialog: boolean,
    urlDialogVisible: boolean, isDeleting: boolean, isLoading: boolean,
} = {
    data: [],
    domains: [],
    dialogVisible: false,
    configName: "",
    root: false,
    createFormOpen: false,
    submitErrors: [],
    displayDeleteCompanyDialog: false,
    targetRealm: "",
    targetIdpAlias: "",
    displayUserExistingDialog: false,
    urlDialogVisible: false,
    isDeleting: false,
    isLoading: true,
}

type State = typeof InitialState;

export default class IdpList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            data: [],
            domains: [],
            dialogVisible: false,
            configName: "",
            root: false,
            createFormOpen: false,
            submitErrors: [],
            displayDeleteCompanyDialog: false,
            targetRealm: "",
            targetIdpAlias: "",
            displayUserExistingDialog: false,
            urlDialogVisible: false,
            isDeleting: false,
            isLoading: true,
        };
    }

    private getIdps = () => {
        this.setState({ isLoading: true });
        getIdentityProviders().then((dataArray) => {
            this.setState({ data: JSON.parse(dataArray) });
            var domainArray:  string[] = [];
            this.state.data.forEach((idp) => {
                idp.config.guiOrder?.split(',').forEach((domain) => {
                    domainArray.push(domain);
                })
            });
            this.setState({ domains: domainArray, isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
    }

    private getPermissions = () => {
        getApplicationPermissions().then((dataArray) => {
            dataArray.applications.forEach((perm: any) => {
                if (perm.name === "PortalAdmin@") {
                    if (perm.roles.indexOf("root") > -1) {
                        this.setState({ root: true });
                    }
                }
            });
        })
    }

    componentDidMount() {
        this.getIdps();
        this.getPermissions();
    }

    private toggleDialog = (name?: string) => {
        this.setState({
            dialogVisible: !this.state.dialogVisible,
            configName: name ?? ''
        });
    };

    private toggleUrlDialog = (name?: string) => {
        this.setState({
            urlDialogVisible: !this.state.urlDialogVisible,
            configName: name ?? ''
        });
    };

    private submit = (e: SwitchChangeEvent, idp: IdPEntity) => {
        idp.enabled = !idp.enabled;
        var newInputArray: IdPEntity[] = [];
        updateIdp(idp).then
            ((res) => {
                this.state.data.forEach((input) => {
                    if (input === idp) {
                        newInputArray.push(idp);
                    }
                    else {
                        newInputArray.push(input);
                    }
                });
                this.getIdps();
            }).catch((error) => {
                alert(error);
            });
    };

    private generateInput = (idp: IdPEntity) => {
        var domainArray: string[] = []
        if (idp.config.guiOrder) {
            domainArray = idp.config.guiOrder.split(',');
        }
        domainArray.push('');
        return domainArray;
    }

    private delaySaveOfGuiOrder = (e: React.ChangeEvent<any>, idp: IdPEntity, domain: string) => {
        e.persist();
        e.target.value = e.target.value.trim();
        let newValue = e.target.value;
        var guiArray: string[] = [];
        const domainPattern = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i

        if (idp.config && idp.config.guiOrder) {
            guiArray = idp.config.guiOrder.split(',');
        }
        var arrTarget = Number(e.target.name);
        var domainsLength = e.target.parentElement.parentElement.querySelectorAll(".domainInput").length - 1;
        //If user deletes input
        if (newValue === "") {
            var newInputArray: IdPEntity[] = [];
            this.state.data.forEach((input) => {
                if (input === idp) {
                    guiArray.splice(arrTarget, 1);
                    idp.config.guiOrder = guiArray.toString();
                    newInputArray.push(idp);
                }
                else {
                    newInputArray.push(input);
                }
            });
            this.setState({ data: newInputArray });
            if (e.target.refreshTimer) {
                clearTimeout(e.target.refreshTimer);
            }
            e.target.refreshTimer = setTimeout(() => {
                var domainArray: string[] = [];
                this.state.data.forEach((idp) => {
                    let guiArray: string[] = [];
                    if (idp.config && idp.config.guiOrder) {
                        guiArray = idp.config.guiOrder.split(',');
                    }
                    guiArray.forEach((domain) => {
                        domainArray.push(domain);
                    })
                })
                this.setState({ domains: domainArray });
                updateIdp(idp);
                this.saveAlert(e.target.id);
            }, 1000);
        }
        //If user edits input
        else if (newValue !== "") {
            var newInputArray: IdPEntity[] = [];
            //Adds the value in the input to the idps config guiOrder. 
            this.state.data.forEach((input) => {
                if (input === idp) {
                    guiArray[arrTarget] = newValue;
                    idp.config.guiOrder = guiArray.toString();
                    newInputArray.push(idp);
                }
                else {
                    newInputArray.push(input);
                }
            })
            this.setState({ data: newInputArray });

            if (e.target.refreshTimer) {
                clearTimeout(e.target.refreshTimer);
            }
            e.target.refreshTimer = setTimeout(() => {
                var oldDomains: string[] = [];
                oldDomains = this.state.domains;
                //Check if current value in input is in the domains in state.
                if (oldDomains.indexOf(newValue) > -1) {
                    var newInputArray: IdPEntity[] = [];
                    this.state.data.forEach((input) => {
                        if (input === idp) {
                            guiArray.splice(arrTarget, 1);
                            idp.config.guiOrder = guiArray.toString();
                            newInputArray.push(idp);
                        }
                        else {
                            newInputArray.push(input);
                        }
                    });
                    this.setState({ data: newInputArray });
                    this.errorAlert(e.target.id);
                }
                else {
                    //If it wasn't in the domains in state, add it by looping from idps in state.
                    var domainArray: string[] = [];
                    this.state.data.forEach((idp) => {
                        let guiArray: string[] = [];
                        if (idp.config && idp.config.guiOrder) {
                            guiArray = idp.config.guiOrder.split(',');
                        }
                        guiArray.forEach((domain) => {
                            domainArray.push(domain);
                        })
                    })
                    // if (domainPattern.test(domain)) {
                    updateIdp(idp).then
                        ((res) => {
                            this.setState({ domains: domainArray });
                            this.saveAlert(e.target.id);
                        }).catch((error) => {
                            alert(error);
                        });
                    /*} else {
                        this.errorAlert(e.target.id,"Invalid domain name.");
                    }*/
                }
            }, 1000);
        }
    }
    public toggleCreateDialog = () => {
        this.setState({
            createFormOpen: !this.state.createFormOpen
        });
    };
    public handleCancelCreate = () => {
        this.toggleCreateDialog();
        this.setState({ submitErrors: [] });
    }
    public handleFormClose = () => {
        this.setState({
            createFormOpen: false,
        }, () => {
            this.getIdps();
        });
    }

    private saveAlert(id: string) {
        if (document.getElementById(id + "savedlabel") !== null) {
            document.getElementById(id + "savedlabel")!.innerHTML = "Saved";
            document.getElementById(id + "savedlabel")!.style.display = "inline";
            setTimeout(() => {
                document.getElementById(id + "savedlabel")!.style.display = "none";
            }, 1000);
        }
    }

    private errorAlert(id: string, pMessage: string = "Domain name already used in this IDP or another.") {
        document.getElementById(id + "savedlabel")!.innerHTML = pMessage;
        document.getElementById(id + "savedlabel")!.style.display = "inline";
        setTimeout(() => {
            document.getElementById(id + "savedlabel")!.style.display = "none";
        }, 1000);
    }

    private onChangeDisplayName(pEvent: SyntheticEvent) {

        let pTarget:any = pEvent.target;

        if (pTarget.refreshTimer) {
            clearTimeout(pTarget.refreshTimer);
        }
        if (pTarget.value.trim() == "") {
            pEvent.preventDefault();
            pEvent.stopPropagation();
            pTarget.value = pTarget.defaultValue;
        } else {
            pTarget.refreshTimer = setTimeout(() => {
                pTarget.disabled = true;
                let idps: any[] = [...this.state.data];
               let idp:any = {};
                idps = idps.map((el) => {
                    if (el.alias == pTarget.id) {
                        idp = el;
                        pTarget.value = pTarget.value.trim();
                        el.displayName = pTarget.value;
                    }
                    return el;
                })
                this.setState({ data: idps });
                updateIdp(idp).then
                    ((res) => {
                        pTarget.disabled = false;
                        this.saveAlert(pTarget.id);
                    }).catch((error) => {
                        pTarget.disabled = false;
                        alert(error);
                    });
           },1000);

        }
    }
    private handleDomainKeyDown(e:React.KeyboardEvent<HTMLInputElement>) {
        if (e.key == ",") {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    public handleClickDelete = (realmName: string, idpAlias: string) => {
        getRealmUserCount(realmName)
            .then(result => {
                if (result > 0) {
                    this.setState({
                        displayUserExistingDialog: true,
                        targetRealm: realmName
                    })
                } else {
                    this.setState({
                        displayDeleteCompanyDialog: true,
                        targetRealm: realmName,
                        targetIdpAlias: idpAlias
                    })
                }
            })
            .catch(error => {
                console.error("Error retrieving user count:", error);
            });
    }

    public closeUserExistingDialog = () => {
        this.setState({
            displayUserExistingDialog: false,
            targetRealm: "",
            targetIdpAlias: ""
        })
    }

    public closeDeleteCompanyDialog = () => {
        this.setState({
            displayDeleteCompanyDialog: false,
            targetRealm: "",
            targetIdpAlias: ""
        })
    }

    public handleDeleteCompanyConfirmation = async () => {
        this.setState({ isDeleting: true });
        const realm = this.state.targetRealm;
        const idpAlias = this.state.targetIdpAlias;
        deleteCompany(realm, idpAlias)
            .then(() => {
                this.setState(prevState => ({
                    data: prevState.data.filter(company => company.alias !== idpAlias)
                }));
                this.setState({ isDeleting: false });
                this.closeDeleteCompanyDialog();
            })
            .catch(error => {
                this.setState({ isDeleting: false });
                console.error("Error deleting company:" + realm, error);
            });
    }

    render() {
        return (
            <>
                <div style={{ margin: "3% 3% 4% 3%" }}>
                    <br/>
                    <h3 style={{ display: "inline-block" }}>Companies</h3> <span> {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />} </span>
                    {this.state.root && (
                        <>
                            <button className="btn btn-primary" onClick={this.toggleCreateDialog} style={{ width: "175px", float:"right", marginBottom:"25px" }} >New company</button>
                            {this.state.data.map((idp, i) => (
                                <div className="card" key={idp.alias + i}>
                                    <div className="card-body" key={idp.alias + i + "body"}>
                                    <h5 className="gds-tab inline-tab" key={idp.alias + i + "h5"}>Company key : {idp.alias.replace("_IDP","")}</h5>
                                    <br/>
                                        <label htmlFor="displayName">Display Name :&nbsp;</label>
                                        <input type="text" name="displayName" id={idp.alias} defaultValue={idp.displayName} onInput={(e) => { this.onChangeDisplayName(e) }} />
                                        <label id={idp.alias + "savedlabel"} htmlFor={idp.alias} key={idp.alias + "savedlabel"} className="gds-body" style={{ display: "none" }} ></label>

                                        <button className="btn btn-primary" style={{ float: 'right', width: '150px', marginBottom: '10px' }} key={idp.alias + i + "configButton"} onClick={() => this.toggleDialog(idp.alias)} disabled={!this.state.root}> Applications </button>
                                        <br style={{ clear: 'both' }} />
                                        <button className="btn btn-primary" style={{ float: 'right', width: '150px', marginBottom: '10px' }} key={idp.alias + i + "urlConfigButton"} onClick={() => this.toggleUrlDialog(idp.alias)} disabled={!this.state.root}> URL Configuration </button>

                                        <br style={{ clear: 'both' }} />
                                        <div style={{ float: 'right', marginBottom: '10px' }}>
                                            <label key={idp.alias + i + "firstLabel"} htmlFor="button" className="gds-body">{idp.enabled ? "Enabled" : "Disabled"}</label>&nbsp;
                                            <Switch checked={idp.enabled} key={idp.alias + i + "button"} value={idp.displayName} data-value={idp.enabled} onChange={(e) => { this.submit(e, idp) }} />
                                        </div>
                                        <br style={{ clear: 'both' }} />
                                        {!idp.enabled && idp.alias.replace("_IDP", "") != "GDSLINK" && (
                                            <button className="btn btn-primary-sm delete" style={{ float: 'right', width: 'auto' }}
                                                onClick={() => { this.handleClickDelete(idp.alias.replace("_IDP", ""), idp.alias); }} disabled={idp.enabled}>Delete Company</button>
                                        )}
                                        <br key={idp.alias + i + "br"} />
                                        <p style={{ marginTop: "5px", marginBottom: "2px" }} className="gds-body" key={idp.alias + i + "text"}>Domain Names:</p>
                                        {this.generateInput(idp).map((domain, index) => (
                                            <div key={idp.alias + index + "mapDiv"}>
                                                <input style={{ marginBottom: "2px" }} id={idp.alias + index.toString()} className="domainInput gds-input-normal" type="text" value={domain} name={index.toString()} key={idp.alias + index + "input"} onKeyDown={this.handleDomainKeyDown} onChange={(e) => { this.delaySaveOfGuiOrder(e, idp, domain) }} />
                                                <label id={idp.alias + index.toString() + "savedlabel"} htmlFor={idp.alias + index.toString()} key={idp.alias + index + "savedlabel"} className="gds-body" style={{ display: "none" }} >Saved</label>
                                                <br key={idp.alias + i + "br2"} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))

                            }

                            {this.state.createFormOpen && <CompanyCreateForm handleClose={this.handleCancelCreate} submitErrors={this.state.submitErrors} handleFormClose={this.handleFormClose} />}
                        </>
                    )}
                    {!this.state.root && (
                        <>
                            <h3 style={{ display: (this.state.root?"block":"none")}}>"User must be root to use this functionality"</h3>
                        </>
                    )}
                    {this.state.dialogVisible && (<IdpConfigureForm toggleDialog={this.toggleDialog} configName={this.state.configName} realmName={this.state.configName.slice(0, -4)} />)}
                    {this.state.urlDialogVisible && (<CompanyUrlsForm toggleDialog={this.toggleUrlDialog} companyName={this.state.configName.slice(0, -4)} />)}
                </div>
                <div className="support-footer" style={{ width: "100%" }}>
                    <SupportTeam></SupportTeam>
                </div>
                <Dialog style={{ display: (this.state.displayDeleteCompanyDialog ? 'flex' : 'none') }} title={"Please confirm"} onClose={(e) => {if (!this.state.isDeleting) {this.closeDeleteCompanyDialog();}}}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        Do you really want to delete company {this.state.targetRealm} ?
                    </p>
                    <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => this.closeDeleteCompanyDialog()} disabled={this.state.isDeleting}>
                            No
                        </button>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={this.handleDeleteCompanyConfirmation} disabled={this.state.isDeleting}> 
                            {this.state.isDeleting ? (<span><span className="k-icon k-i-loading" style={{ marginRight: 8 }}></span>Deleting...</span>) : ('Yes')}
                        </button>
                    </DialogActionsBar>
                </Dialog>
                <Dialog style={{ display: (this.state.displayUserExistingDialog ? 'flex' : 'none') }} title={"Existing Users"} onClose={() => this.closeUserExistingDialog()}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        Please remove all users associated with {this.state.targetRealm} before deleting it.
                    </p>
                    <DialogActionsBar>
                        <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={() => this.closeUserExistingDialog()}>
                            Ok
                        </button>
                    </DialogActionsBar>
                </Dialog>
            </>
        )
    }
}